import { Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

const DeleteButton = ({
  url,
  toggle = () => null,
  isIcon,
  color,
  className,
  children,
}) => {
  const button = isIcon ? (
    <Trash2 color="red" />
  ) : (
    <Button
      color={color ?? "danger"}
      className={`btn-warning w-100 d-flex justify-content-start align-items-center ${className}`}
    >
      <Trash2 size={12} />
      {children}
    </Button>
  );

  return url ? (
    <Link to={url}>{button}</Link>
  ) : (
    <Link
      onClick={(e) => {
        e.preventDefault();
        toggle();
      }}
    >
      {button}
    </Link>
  );
};

export default DeleteButton;
